const LIBRARY_SCENE_LOAD_PROGRESS_EVENT = "critter:library-scene-load-progress";

const dispatchLibrarySceneLoadProgressEvent = (detail) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(LIBRARY_SCENE_LOAD_PROGRESS_EVENT, { detail }));
};

export const beginLibrarySceneLoadProgress = ({ label = "Asset", catalogId = "" } = {}) => {
  dispatchLibrarySceneLoadProgressEvent({
    type: "begin",
    label: String(label || "Asset"),
    catalogId: String(catalogId || ""),
  });
};

export const reportLibrarySceneLoadProgress = (progress) => {
  const value = Math.min(1, Math.max(0, Number(progress) || 0));
  dispatchLibrarySceneLoadProgressEvent({ type: "progress", progress: value });
};

export const endLibrarySceneLoadProgress = () => {
  dispatchLibrarySceneLoadProgressEvent({ type: "end" });
};

export const subscribeLibrarySceneLoadProgress = (handler) => {
  if (typeof window === "undefined" || typeof handler !== "function") {
    return () => {};
  }
  const listener = (event) => handler(event.detail || {});
  window.addEventListener(LIBRARY_SCENE_LOAD_PROGRESS_EVENT, listener);
  return () => window.removeEventListener(LIBRARY_SCENE_LOAD_PROGRESS_EVENT, listener);
};
